import React from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import { BRANCH_ADMIN, INTERNAL_ADMIN, StatusList, getIcon } from "common/constants/constants";
import SearchField from "components/common/customSearchField/CustomSearchField";
import SearchableSelect from "components/common/searchableSelect/SearchableSelect";
import SortingOrder from "components/common/sortingOrder/SortingOrder";

import ClearFiltersIcon from "../../../assets/icons/ClearFiltersIcon";
import { useTranslation } from "react-i18next";
const ApiUserActionBar = (props) => {
  const { t } = useTranslation();

  const {

    handleChange,

    searchPlaceholder,
    filters,
    orderByList,
    resetFilters,
  } = props;
  return (
    <Container>
      <Row>
        <Col
          lg={1}
          md={2}
          xs={12}
          className="d-flex flex-md-column align-items-center  justify-content-md-center justify-content-around align-item-center flex-row">
          {filters.orderBy ? (
            <SortingOrder handleChange={handleChange} value={filters.orderType} />
          ) : (
            <div
              style={{
                pointerEvents: "none",
                opacity: 0.4,
              }}>
              <SortingOrder handleChange={handleChange} value={filters.orderType} />
            </div>
          )}
          {Object.values(filters).some((el) => el !== "DESC" && el.length > 0) && (
            <ClearFiltersIcon resetFilters={resetFilters} />
          )}
        </Col>
        <Col lg={3} md={10} xs={12}>
          <SearchableSelect
            name="orderBy"
            placeholder={t("sort-by")}
            options={orderByList.map((el) => {
              return { value: el.value, label: el.name };
            })}
            value={filters.orderBy}
            handleChange={handleChange}
          />

        </Col>
        <Col lg={3} md={6} xs={12}>
          <SearchableSelect
            placeholder={t("status")}
            name="status"
            options={StatusList.map((status) => {
              return { value: status.value, label: t(status.label) };
            })}
            handleChange={(key, value) => handleChange(key, value)}
            value={filters?.status}
            isMulti={false}
            className=" eg-bar-select "
          /></Col>
        <Col lg={3} md={6} xs={12}>
       
          <SearchField
            name="searchString"
            placeholder={searchPlaceholder}
            value={filters.searchString}
            margin="6px"
            {...props}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default ApiUserActionBar;
